<template>
  <div class="complete">
    <!--查询结果-->
    <div>
      <div class="title"><span>查询结果</span></div>
      <div class="remind">
        依<span class="font-bold">{{ checkData.cxsqr }}</span
        >的申请，经查询, 查档编号:{{
          checkData.cxbh
        }}(自助查询系统)，共有<span class="font-bold">{{
          checkData.bdcxxList ? checkData.bdcxxList.length : 0
        }}</span
        >套房产结果如下:
      </div>
      <!--没有数据-->
      <div v-if="!checkData.bdcxxList || checkData.bdcxxList.length < 1">
        <table>
          <tr>
            <td class="bgcolorTr">权利人名称：</td>
            <td>{{ checkData.cxsqr }}</td>
            <td class="bgcolorTr">权利人证件号：</td>
            <td>{{ checkData.zjh }}</td>
          </tr>
          <tr>
            <td class="bgcolorTr">查询时间：</td>
            <td colspan="3">{{ nowDate }}</td>
          </tr>
          <tr>
            <td class="bgcolorTr" colspan="4">本次不动产信息查询共0条记录</td>
          </tr>
        </table>
      </div>
      <!--有数据-->
      <div v-else>
        <table v-for="(item, index) in checkData.bdcxxList" :key="index" class="tableData" cellpadding="0" cellspacing="0">
          <tr>
            <td>不动产单元号：</td>
            <td>{{ item.bdcdyh }}</td>
            <td>不动产权证号：</td>
            <td>{{ item.bdcqzh }}</td>
          </tr>
          <tr>
            <td>坐落：</td>
            <td>{{ item.zl }}</td>
            <td>权利人名称：</td>
            <td>{{ item.qlrmc }}</td>
          </tr>
          <tr>
            <td>权利人证件号：</td>
            <td>{{ item.qlrzjh }}</td>
            <td>是否预告抵押：</td>
            <td><dict-span type="是否" :binddata="item.sfygdy"></dict-span></td>
          </tr>
          <tr>
            <td>是否抵押：</td>
            <td><dict-span type="是否" :binddata="item.sfdy"></dict-span></td>
            <td>是否查封：</td>
            <td><dict-span type="是否" :binddata="item.sfcf"></dict-span></td>
          </tr>
          <tr>
            <td>是否异议：</td>
            <td><dict-span type="是否" :binddata="item.sfyy"></dict-span></td>
            <td>是否地役：</td>
            <td><dict-span type="是否" :binddata="item.sfdyi"></dict-span></td>
          </tr>
          <tr>
            <td>是否预告：</td>
            <td><dict-span type="是否" :binddata="item.sfyg"></dict-span></td>
            <td>查询时间：</td>
            <td>{{ nowDate }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="jzxx">
      <el-button class="mt30" type="default" @click="backHomepage" size="small">返回大厅</el-button>
      <el-button :disabled="!checkData.cxbh" :loading="loading" class="mt30" type="primary" @click="printQszm" size="small"
        >查看并下载</el-button
      >
    </div>
  </div>
</template>

<script>
import obj from '@iebdc/router/modules/my-query.js';
import utils from '@/utils/utils';
import { printQszm } from '@iebdc/api/my-query.js';

export default {
  name: 'queryResult',
  props: {
    checkData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
      objPath: obj.path,
      nowDate: '',
    };
  },
  methods: {
    backHomepage() {
      this.$router.go(-1);
    },
    printQszm() {
      this.loading = true;
      printQszm({ cxbh: this.checkData.cxbh }).then((res) => {
        // 202008191735141196
        if (res.data && res.success) {
          window.open(res.data);
          this.loading = false;
        } else {
          this.$message.warning('下载失败!');
        }
      });
    },
  },
  filters: {
    filterTime: function (val) {
      return val ? utils.dateFtt(val, 'yyyy-MM-dd hh:mm:ss') : '';
    },
  },
  mounted() {
    this.nowDate = utils.getNowDate(1);
  },
};
</script>

<style lang="scss" scoped>
.remind {
    color: #303133;
    margin: 10px 0;
    .font-bold {
      font-weight: bold;
    }
  }
.bgcolorTr{
  background: rgb(242, 246, 252);
  text-align: right;
  width: 200px;
}
.mt30 {
  margin-top: 30px;
}
.jzxx {
  text-align: center;
}
.complete {
  .title {
    margin-top: 40px;
    width: 100%;
    height: 46px;
    // border-bottom: 1px solid #e0e0e0;
    font-weight: bolder;
    font-size: 18px;
    color: #303133;
    span {
      line-height: 46px;
      display: inline-block;
      position: relative;
      &:after {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background: #2c8bff;
        content: '';
      }
    }
  }
  table {
    border-collapse: collapse;
    margin-top: 20px;
    width: 100%;
    border: solid #e0e0e0;
    border-width: 1px 0px 0px 1px;
  }
  table tr td {
    height: 36px;
    border: solid #e0e0e0;
    border-width: 0px 1px 1px 0px;
    padding: 0px 10px;
  }
  .tableData tr td:nth-child(2n-1) {
    text-align: right;
    background: rgb(242, 246, 252);
    width: 180px;
    word-break: break-all;
  }
  .tableData tr td:nth-child(2n) {
    width: 400px;
    word-break: break-all;
  }
}
</style>
